import React from 'react';

/**
 * Identity cell: avatar + name + email in one scannable unit.
 * When the user has a profile thumbnail, `avatarUrl` (a fetched blob URL) fills
 * the avatar slot; otherwise it falls back to the deterministic initials avatar.
 * Truncates long values without breaking the row (CSS ellipsis).
 *
 * Props: { name, email, avatarUrl }
 */
const AVATAR_COLORS = ['#2e9b87', '#163a5f', '#f26b45', '#1f4d78', '#7a5cc0', '#0e7490', '#b45309', '#4d7c0f'];

export const initialsOf = (name, email) => {
  const source = (name && name.trim()) || (email && email.trim()) || '';
  if (!source) return '?';
  const parts = source.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return source.slice(0, 2).toUpperCase();
};

export const colorFor = (seed) => {
  const s = String(seed || '');
  let hash = 0;
  for (let i = 0; i < s.length; i++) hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
};

const IdentityCell = ({ name, email, avatarUrl }) => {
  const displayName = (name && name.trim()) || '—';
  const initials = initialsOf(name, email);
  const bg = colorFor(email || name);

  return (
    <div className="uv-identity" data-testid="identity-cell">
      {avatarUrl ? (
        <img
          className="uv-avatar uv-avatar--img"
          src={avatarUrl}
          alt=""
          aria-hidden="true"
          data-testid="identity-avatar-img"
        />
      ) : (
        <span className="uv-avatar" style={{ background: bg }} aria-hidden="true">{initials}</span>
      )}
      <span className="uv-identity__text">
        <span className="uv-identity__name" title={displayName}>{displayName}</span>
        {email ? <span className="uv-identity__email" title={email}>{email}</span> : null}
      </span>
    </div>
  );
};

export default IdentityCell;
